import IntegrationsExternalIdsList from '@/components/integrations/external-ids/IntegrationsExternalIdsList';
import { IResource, Office } from '@gettactic/api';
import { ScrollArea } from '@mantine/core';
import React from 'react';

export interface IntegrationsExternalIdsPanelProps {
  office: Office;
  resources?: IResource[] | null;
}

export const IntegrationsExternalIdsPanel: React.FC<
  IntegrationsExternalIdsPanelProps
> = ({ office, resources }) => {
  return resources ? (
    <ScrollArea type="auto" offsetScrollbars className="h-full">
      <IntegrationsExternalIdsList
        title="External ID's"
        office={office}
        resources={resources}
      />
    </ScrollArea>
  ) : null;
};
